import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-floating-add-question',
  templateUrl: './floating-add-question.component.html',
  styleUrls: ['./floating-add-question.component.scss']
})
export class FloatingAddQuestionComponent {
  @Input('questionType') questionTypes: Array<any> = [];
  @Output('newQuestiontype') newQuestionType = new EventEmitter<string>()


  sendQuestionType(type) {
    console.log("TYPE", type)
    this.newQuestionType.emit(type);

  }
}
